module.exports = __webpack_public_path__ + "img/LydiaSarfati.2ac7c09c.jpg";